export default __webpack_public_path__ + "static/media/banner-petfriendly.0d6eb513.jpeg";